'use strict'
import _ from 'lodash'

// Al momento creo generico e non collego al modulo del protocollo della bilancia. 
// TODO: Completare se usato insieme a gestione esplosione scontrino bilancia

const generaFileBilancia = async (bilancia) => {
  switch (bilancia.protocollo) {
    case 'helmac':
      return await generaFileBilanciaHelmac(bilancia)
    default:
      return []
  }
}

const generaFileBilanciaHelmac = async (bilancia) => {
  let elenco = []
  var value
  for (let p of bilancia.plu) {
    let posizione = 1
    let riga = ''
    for (let h of _.sortBy(bilancia.hft.campi, 'position')) {
      const itemValue = h.value.substring(1)
      switch (h.value[0]) {
        case '#':
          value = _.get(p, itemValue)
          break
        case '@':
          value = _.get(bilancia, itemValue)
          break
        case '*':
          value = _.get(p, itemValue)
          value = h.map[value]
          break
        default:
          value = h.value
          break
      }
      if (h.decimals) {
        value = +(value * Math.pow(10, h.decimals)).toFixed(h.decimals)
      }
      if (h.uppercase) {
        value = value.toUpperCase()
      }
      value = h.align === 'right' ? String(value).substring(0, h.len).padStart(h.len, h.padding) : String(value).substring(0, h.len).padEnd(h.len, h.padding)
      if (h.position !== posizione) {
        riga += _.repeat(' ', h.position - posizione)
      }
      posizione = h.position + h.len
      riga += value
    }
    elenco.push(riga)
  }
  if (bilancia.hft.aggiungeRigaVuota) {
    elenco.push('')
  }
  return elenco
}

export default {
  generaFileBilancia
}